"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_loading_1 = tslib_1.__importDefault(require("react-loading"));
const Loading = (props) => {
    return ((0, jsx_runtime_1.jsx)(react_loading_1.default, { className: props.className || 'spinLoading', type: props.type || 'spin', color: props.color || '#5d78ff', height: props.height || 50, width: props.width || 50 }));
};
exports.default = Loading;
